import { Route, Routes } from "react-router-dom";
import "./App.css";

import ProtectedRoutes from "./components/ProtectedRoutes";
import AppProvider from "./contexts/AppContext";
import Login from "./pages/Login";
import Nomatch from "./pages/Nomatch";
import Dashboard from "./pages/dashboard/Dashboard";
import Admin from "./pages/dashboard/admin/Admin";
import Uploads from "./pages/dashboard/admin/Uploads";
import Employee from "./pages/dashboard/employee/Employee";

function App() {
  return (
    <AppProvider>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route element={<ProtectedRoutes />}>
          <Route path="dashboard" element={<Dashboard />}>
            <Route path="employee" element={<Employee />} />
            <Route path="admin" element={<Admin />} />
            <Route path="admin/uploads" element={<Uploads />} />
          </Route>
        </Route>
        <Route path="*" element={<Nomatch />} />
      </Routes>
    </AppProvider>
  );
}

export default App;
